// Wallboard alarm tones, synthesised with Web Audio: no asset to ship or cache.
// Browsers keep audio locked until the page has had one user gesture, so the
// wallboard shows an "arm" control while the context is suspended.

let ctx: AudioContext | null = null;

export function audioContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  ctx ??= new AC();
  return ctx;
}

/** Unlock audio; must run inside a click/keypress handler. */
export async function armAudio(): Promise<boolean> {
  const c = audioContext();
  if (!c) return false;
  if (c.state === "suspended") await c.resume().catch(() => undefined);
  return c.state === "running";
}

export const audioArmed = () => audioContext()?.state === "running";

function tone(c: AudioContext, at: number, freq: number, len: number, gain: number, type: OscillatorType = "square") {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, at);
  // Short ramps: no clicks at the edges.
  g.gain.setValueAtTime(0, at);
  g.gain.linearRampToValueAtTime(gain, at + 0.01);
  g.gain.setValueAtTime(gain, at + len - 0.02);
  g.gain.linearRampToValueAtTime(0, at + len);
  o.connect(g).connect(c.destination);
  o.start(at);
  o.stop(at + len + 0.02);
}

/**
 * major: an OLT or PON is down -- a two-tone siren, six pulses.
 * minor: a customer ONT is down -- three short beeps.
 */
export function playAlarm(level: "major" | "minor") {
  const c = audioContext();
  if (!c || c.state !== "running") return;
  const t0 = c.currentTime + 0.05;
  if (level === "major") {
    for (let i = 0; i < 6; i++) tone(c, t0 + i * 0.32, i % 2 ? 660 : 990, 0.28, 0.22);
  } else {
    for (let i = 0; i < 3; i++) tone(c, t0 + i * 0.22, 880, 0.14, 0.18);
  }
}
